import { render } from "./LogoutComponent.vue?vue&type=template&id=703b0351"
import script from "./LogoutComponent.vue?vue&type=script&lang=js"
export * from "./LogoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__